import {FinishingForProductionSchedule} from '@domain/production-schedule/finishing-for-production-schedule';
import {InitialFreeZone} from '@domain/production-schedule/free-zone/initial-free-zone';
import {InitialRestZone} from '@domain/production-schedule/rest-zone/initial-rest-zone';
import {CreelMap} from '@domain/textile-data/creel/creel-map';
import {InitialPathLabel} from './initial-path-label';
import {JuteInformation} from './jute-information';

export class InitialOptionsForProductionOrder {
  private _initialRestZones: InitialRestZone;
  private _initialFreeZones: InitialFreeZone;
  private _finishing: FinishingForProductionSchedule;
  private _practicalPickDensityInPicksPerMM: number;
  private _initialPathLabel: InitialPathLabel;
  private _initialJute: JuteInformation;
  private _activeMachineQualityId: number;
  private _activeCreelId: number;
  private _mappingForCurrentPositionOnMachine: CreelMap[];

  public constructor(
    initialRestZones: InitialRestZone,
    initialFreeZones: InitialFreeZone,
    finishing: FinishingForProductionSchedule,
    practicalPickDensityInPicksPerMM: number,
    initialPathLabel: InitialPathLabel,
    initialJute: JuteInformation,
    mappingForCurrentPositionOnMachine: CreelMap[],
    activeMachineQualityId?: number,
    activeCreelId?: number
  ) {
    this._initialRestZones = initialRestZones;
    this._initialFreeZones = initialFreeZones;
    this._finishing = finishing;
    this._practicalPickDensityInPicksPerMM = practicalPickDensityInPicksPerMM;
    this._initialPathLabel = initialPathLabel;
    this._initialJute = initialJute;
    this._activeMachineQualityId = activeMachineQualityId;
    this._activeCreelId = activeCreelId;
    this._mappingForCurrentPositionOnMachine = mappingForCurrentPositionOnMachine;
  }

  public get initialRestZones(): InitialRestZone {
    return this._initialRestZones;
  }

  public get initialFreeZones(): InitialFreeZone {
    return this._initialFreeZones;
  }

  public get finishing(): FinishingForProductionSchedule {
    return this._finishing;
  }

  public get practicalPickDensityInPicksPerMM(): number {
    return this._practicalPickDensityInPicksPerMM;
  }

  public get initialPathLabel(): InitialPathLabel {
    return this._initialPathLabel;
  }

  public get initialJute(): JuteInformation {
    return this._initialJute;
  }

  public get mappingForCurrentPositionOnMachine(): CreelMap[] {
    return this._mappingForCurrentPositionOnMachine;
  }

  public get activeMachineQualityId(): number {
    return this._activeMachineQualityId;
  }

  public get activeCreelId(): number {
    return this._activeCreelId;
  }

  public static fromJSON(initialOptionsForMachineAndMachineQualityJSON: any): InitialOptionsForProductionOrder {
    return new InitialOptionsForProductionOrder(
      InitialRestZone.fromJSON(initialOptionsForMachineAndMachineQualityJSON.initialRestZones),
      InitialFreeZone.fromJSON(initialOptionsForMachineAndMachineQualityJSON.initialFreeZones),
      FinishingForProductionSchedule.fromJSON(initialOptionsForMachineAndMachineQualityJSON.finishing),
      initialOptionsForMachineAndMachineQualityJSON.practicalPickDensityInPicksPerMM,
      InitialPathLabel.fromJSON(initialOptionsForMachineAndMachineQualityJSON.initialPathLabelSettings),
      JuteInformation.fromJSON(initialOptionsForMachineAndMachineQualityJSON.initialJuteSettings),
      initialOptionsForMachineAndMachineQualityJSON.mappingForCurrentPositionOnMachine as CreelMap[],
      initialOptionsForMachineAndMachineQualityJSON.machineQuality?.id,
      initialOptionsForMachineAndMachineQualityJSON.creel?.id
    );
  }
}
